
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Rectangle 16800","fill":"none","stroke":"#bebebe","stroke-width":".5"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"3","stroke":"none"}}),_c('rect',{attrs:{"x":".25","y":".25","width":"19.5","height":"19.5","rx":"2.75"}})]),_c('path',{attrs:{"data-name":"Rectangle 16801","d":"M3 0h14a3 3 0 013 3v6H0V3a3 3 0 013-3z","fill":"#bebebe"}})])
          )
        }
      }
    